import { RequestState } from '../../../types'
import { CertficateSettingsAction } from './actions'
import { Certificate, CertificateSettingsState } from "./store"

export const LOAD_ACCOUNT_CERTIFICATES_REQUEST = 'LOAD_ACCOUNT_CERTIFICATES_REQUEST'
export const LOAD_ACCOUNT_CERTIFICATES_RECEIVED = 'LOAD_ACCOUNT_CERTIFICATES_RECEIVED'
export const LOAD_ACCOUNT_CERTIFICATES_ERROR = 'LOAD_ACCOUNT_CERTIFICATES_ERROR'
export const LOAD_AVAILABLE_CERTIFICATES_REQUEST = 'LOAD_AVAILABLE_CERTIFICATES_REQUEST'
export const LOAD_AVAILABLE_CERTIFICATES_RECEIVED = 'LOAD_CERTIFICATES_RECEIVED'
export const LOAD_AVAILABLE_CERTIFICATES_ERROR = 'LOAD_AVAILABLE_CERTIFICATES_ERROR'
export const ADD_ACCOUNT_CERTIFICATE_REQUEST = 'ADD_ACCOUNT_CERTIFICATE_REQUEST'
export const ADD_ACCOUNT_CERTIFICATE_RECEIVED = 'ADD_ACCOUNT_CERTIFICATE_RECEIVED'
export const ADD_ACCOUNT_CERTIFICATE_ERROR = 'ADD_ACCOUNT_CERTIFICATE_ERROR'
export const UPDATE_CERT_FORM_FIELD = 'UPDATE_CERT_FORM_FIELD'
export const REMOVE_ACCOUNT_CERTIFICATE_REQUEST = 'REMOVE_ACCOUNT_CERTIFICATE_REQUEST'
export const REMOVE_ACCOUNT_CERTIFICATE_RECEIVED = 'REMOVE_ACCOUNT_CERTIFICATE_RECEIVED'
export const REMOVE_ACCOUNT_CERTIFICATE_ERROR = 'REMOVE_ACCOUNT_CERTIFICATE_ERROR'

export function certificateSettingsReducer(state: CertificateSettingsState, action: CertficateSettingsAction) {
  switch (action.type) {
    case LOAD_ACCOUNT_CERTIFICATES_REQUEST: {
      return {
        ...state,
        list: {
          ...state.list,
          requestState: RequestState.Loading
        }
      }
    }

    case LOAD_ACCOUNT_CERTIFICATES_RECEIVED: {
      return {
        ...state,
        list: {
          ...state.list,
          certificates: action.certificates,
          requestState: RequestState.Loaded
        }
      }
    }

    case LOAD_ACCOUNT_CERTIFICATES_ERROR: {
      return {
        ...state,
        list: {
          ...state.list,
          requestState: RequestState.Error
        }
      }
    }

    case LOAD_AVAILABLE_CERTIFICATES_REQUEST: {
      return {
        ...state,
        add: {
          ...state.add,
          requestState: RequestState.Loading
        }
      }
    }

    case LOAD_AVAILABLE_CERTIFICATES_RECEIVED: {
      return {
        ...state,
        add: {
          ...state.add,
          catalogue: action.certificates,
          requestState: RequestState.Loaded
        }
      }
    }

    case LOAD_AVAILABLE_CERTIFICATES_ERROR: {
      return {
        ...state,
        add: {
          ...state.add,
          requestState: RequestState.Error
        }
      }
    }
    case UPDATE_CERT_FORM_FIELD: {
      return {
        ...state,
        add: {
          ...state.add,
          [action.key]: action.value
        }
      }
    }

    case REMOVE_ACCOUNT_CERTIFICATE_REQUEST: {
      return {
        ...state,
        contacts: state.list.certificates.map((certificate: Certificate) => {
          if (certificate.id === action.certificateId) {
            return {
              ...certificate,
              deleteRequestState: RequestState.Loading
            }
          } else {
            return certificate
          }
        })
      }
    }

    case REMOVE_ACCOUNT_CERTIFICATE_RECEIVED: {
      return {
        ...state,
        contacts: state.list.certificates.filter((certificate: Certificate) => certificate.id !== action.certificateId)
      }
    }

    case REMOVE_ACCOUNT_CERTIFICATE_ERROR: {
      return {
        ...state,
        contacts: state.list.certificates.map((certificate: Certificate) => {
          if (certificate.id === action.certificateId) {
            return {
              ...certificate,
              deleteRequestState: RequestState.Error
            }
          } else {
            return certificate
          }
        })
      }
    }

    default: {
      return state
    }
  }
}
